import NotificationComponent from '@src/helpers/_showNotifications';
import { ProcessComparison } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import React, { Component } from 'react';
import uuid from 'uuidv4';

import ConditionFooter from './ConditionFooter';
import ConditionRules from './ConditionRules';
import { ConditionWrapper, GhostButton } from './WorkflowConditionsModalStyles';

interface propType  {
  condition: any;
  delete: boolean;
  deleteCondition: Function;
  availableProcess: any;
  onCancel: Function;
  updateRules: Function;
  handleOperation: Function;
  currentConditionNexts: any;
  setConditionNext: Function;
  setNext: Function;
}

interface stateType {
  conditionRules: any;
  componentList: any;
  optionListRule: any;
  next: string;
}

export default class Condition extends Component<propType, stateType> {
  constructor(props: propType){
    super(props)

    this.state = {
      componentList: [],
      optionListRule: [],
      conditionRules: [{
        component_id: '',
        section_id: '',
        operation: ProcessComparison.EQUAL,
        value: '',
        id: uuid()
      }],
      next: ''
    }
  }


  UNSAFE_componentWillMount() {
    const { condition } = this.props;
    if(condition.rules && condition.rules.length > 0){
      this.setState({ conditionRules: condition.rules  })
    }
  }
  
  UNSAFE_componentWillReceiveProps(nextProps: any){
    const { condition } = nextProps;
      if(condition.rules && condition.rules.length > 0){
        this.setState({conditionRules: condition.rules})
      }

  }

  handleInput = async (value: any, id: string) => {
      const { conditionRules } = this.state
      const { updateRules, condition } = this.props;
      const index = conditionRules.findIndex((condition: any) => condition.id === id)
      const newConditionRule = Object.assign({}, conditionRules[index], {value})
      conditionRules[index] = newConditionRule

      this.setState({conditionRules})
      updateRules(condition.id, conditionRules)
  }

  updateOperation = (value: number) => {
    const { handleOperation, condition } = this.props
    handleOperation(value, condition.id);
  }

  createComponentList = async (processId: any) => {
    const { availableProcess } = this.props;

    const componentsRule = availableProcess.sections.filter((obj: any) => obj.id === processId)
    const componentList: any = [];
    const optionListRule: any = [];

    if(componentsRule !== undefined){
      for(let components of componentsRule){
        for(let component of components.components){
          componentList.push(component);
          for(let option of component.options){
            optionListRule.push(option)
          }
        }
      }
    }

    this.setState({optionListRule, componentList})
  }
  
  handleSectionEdit = async (value: string, id: string) => {
    const { conditionRules } = this.state
    const { condition, updateRules } = this.props;

    const index = conditionRules.findIndex((condition: any) => condition.id === id)
    const newConditionRule = Object.assign({}, conditionRules[index], {section_id: value})
    conditionRules[index] = newConditionRule    
    conditionRules[index].component_id = '';
    conditionRules[index].value = '';
    this.createComponentList(value)
    this.setState({conditionRules})
    updateRules(condition.id, conditionRules)
  }
  
  handleRuleEdition = async (value: number | string, id: string, propertie: string) => {    
    const { conditionRules } = this.state
    const { updateRules, condition } = this.props

    const index = conditionRules.findIndex((condition: any) => condition.id === id)
    
    const editedPropertie = {}
    editedPropertie[propertie] = value

    
    const newConditionRule = Object.assign({}, conditionRules[index], editedPropertie)
    conditionRules[index] = newConditionRule
    

   
    this.setState({conditionRules})
    updateRules(condition.id, conditionRules)
  }

  setConditionNextValue = (value: any) => {
    const { condition } = this.props;
    this.props.setNext(value)
    this.props.setConditionNext(value, condition.id);
  }

  addRule = () => {
    const { conditionRules } = this.state
    const { updateRules, condition } = this.props

    const newConditionRules = conditionRules

    const newRule = {
      component_id: undefined,
      operation: ProcessComparison.EQUAL,
      value: undefined,
      id: uuid()
    }
 
    newConditionRules.push(newRule)
    this.setState({conditionRules: newConditionRules})
    updateRules(condition.id, conditionRules)
  }

  deleteRule = async (id: string) => {
    const {conditionRules} = this.state;
    if(conditionRules.length > 1){
      const { updateRules, condition } = this.props
      const newConditionRules = conditionRules.filter((condition: any) => condition.id !== id)
      this.setState({conditionRules: newConditionRules})
      updateRules(condition.id, conditionRules)
    } else {
      NotificationComponent.Notify('error', I18n.l('workflow.validation.error'), I18n.l('workflow.condition.must.have.validation'))
    }
  }

  render(){
    const { conditionRules, next, optionListRule, componentList, sectionSelected } = this.state
    const { condition, availableProcess, currentConditionNexts } = this.props
    
    return (
      <ConditionWrapper className={condition.broken ? 'broken' : ''}>
        <h3>
        {`${I18n.l('formflow.labels.condition')} ${condition.index}`}
        </h3>
        
        {conditionRules.map((condition: any) => <ConditionRules key={condition.index} 
        handleInput={(e: any) => this.handleInput(e, condition.id)}
        handleComparison={(value: string) => this.handleRuleEdition(value, condition.id, 'operation')}
        handleComponent={(value: string) => this.handleRuleEdition(value, condition.id, 'component_id')}
        handleSection={(value: string) => this.handleSectionEdit(value, condition.id)}
        sectionSelected={condition.section_id}
        deleteRule={() => this.deleteRule(condition.id)}
        component_id={condition.component_id}
        optionListRule={optionListRule}
        componentList={componentList}
        operation={condition.operation}
        value={condition.value}
        availableProcess={availableProcess}/>)}

        <GhostButton style={{margin: '2% 0'}} onClick={this.addRule}>+ {I18n.l('process.conditions.addNewRule')}</GhostButton>
        
        <ConditionFooter 
        operation={condition.operation}
        handleOperation={this.updateOperation}
        deleteCondition={this.props.deleteCondition}
        delete={this.props.delete}
        currentConditionNexts={currentConditionNexts}
        setConditionNext={this.setConditionNextValue}
        condition={condition}
        next={next}/>
  
      </ConditionWrapper>
      )
  }
  
  }
